import api from './api';

const supportTicketService = {
    listTickets:   (params = {}) => api.get('/support/tickets', { params: { ...params } }),
    createTicket:  (data)        => api.post('/support/tickets', data),
    getTicket:     (id)          => api.get(`/support/tickets/${id}`),
    updateStatus:  (id, status)  => api.put(`/support/tickets/${id}`, { status }),
    addComment:    (id, message) => api.post(`/support/tickets/${id}/comments`, { message }),
    // A chain (JSM organization) or hotel (component) on the support desk — entity 'chain' | 'hotel' (V671).
    getDesk:       (entity, id)  => api.get(`/support/desk/${entity}/${id}`),
    addToDesk:     (entity, id)  => api.post(`/support/desk/${entity}/${id}`, {}),
};

export default supportTicketService;
